import React from "react";
import "./WorkForUsPage.scss";
import ImgWhiteTemplate from "../../templates/ImgWhiteTemplate/ImgWhiteTemplate";
import {
  backgroundArtArray,
  londonPhotosArray,
  windmillPhotosArray,
} from "../../assets/assetReference";
import RedLineText from "../../components/RedLineText/RedLineText";
import { companyInformation } from "../../data/content/content";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function WorkForUsPage() {
  return (
    <>
      <Helmet>
        <title>Work for Us | WeBridge</title>
        <meta
          name="description"
          content="WeBridge is a consulting firm bridging European offshore wind developers and international suppliers, providing expert services for the renewable energy industry. Learn more about how to join us and work for us."
        />
        <meta
          name="keywords"
          content="WeBridge, wind energy bridge, offshore wind energy, work for us, join us"
        />
      </Helmet>
      <div className={"work-for-us-page-container"}>
        <ImgWhiteTemplate
          backgroundImg={{
            src: londonPhotosArray[0],
            alt: "a photo of landscape of london",
            type: "img",
          }}
          h1="Work for Us"
          description={
            <span>
              <span className="text-main">Join our team</span> and be part of a
              dynamic organization driving innovation in the offshore wind
              industry.
            </span>
          }
        />
        <OtherContent />
      </div>
    </>
  );
}

function OtherContent() {
  return (
    <div className="relative py-[100px] pb-[150px] w-[70vw] min-w-[600px] mx-auto">
      <h2 className="text-4xl font-headings mb-8">Join Us</h2>
      <img
        className="absolute bottom-0 left-[40vw] w-[40vw] opacity-20"
        src={backgroundArtArray.windmillArt}
        alt="2d offshore windmill art for background"
      />
      <RedLineText
        TextContent={
          <div className="space-y-4 leading-relaxed font-body text-lg">
            <p className="font-light">
              Interested in joining a diversified organisation with a mission to
              foster international collaboration in the offshore wind sector and
              contribute to a sustainable future?
            </p>
            <p className="font-bold">
              We are always on the look out for talented individuals to join our
              team.
            </p>
            <p>
              Please send your CV to{" "}
              <a
                href={`mailto:${companyInformation.email}`}
                className="text-main"
              >
                {companyInformation.email}
              </a>
              .
            </p>
          </div>
        }
      />
    </div>
  );
}
